import React from "react";
//import { useEffect } from "react";
// import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import * as FileSaver from "file-saver";
// import * as XLSX from "xlsx";
import { useEffect,useRef } from "react";
import api from "../../utils/api";
import { useState } from "react";
import isEmpty from "lodash/isEmpty";
import { toast } from "react-toastify";
import { getUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import Spinner from "../../common/Spinner/Spinner";
import UserProfileModal from "../../components/ServiceRequests/Handholder/UserProfileModal";
//import UserServiceFeedbackModal from "../../components/ServiceRequests/Handholder/UserServiceFeedbackModal";
import UserFeedbackModal from "../../components/ServiceRequests/Handholder/UserFeedbackModal";
import find from "lodash/find";
import useDebouncedEffect from "../../hoc/useDebouncedEffect";
import { getServiceTypesMaster } from "../../utils/localStorage";
import FacilitatorFilterSection from "../../components/ServiceRequests/Facilitator/FacilitatorFilterSection";
import MyResourceFilter from "../../components/ServiceRequests/Facilitator/MyResourceFilter";
import SPMFilterModel from "../../components/ServiceRequests/Facilitator/SPMFilterModel";
import EngagementFiltersModal from "../../components/ServiceRequests/Facilitator/EngagementFiltersModal";
import FacilitatorServiceTable from "../../components/ServiceRequests/Facilitator/FacilitatorServiceTable";
import MyResourceTable from "../../components/ServiceRequests/Facilitator/MyResourceTable";
import axios from 'axios'; 
import ToolsTemplateFilterModal from "../../components/ServiceRequests/Admin/ToolsTemplateFilterModal";


export default function MyResourceAssignmentContainer(props)
{

	const [clearCount, setClearCount] = useState(0);
	const [showFilterModal,setshowFilterModal] = useState(false);
	const toggleFilterModal=()=>{
        setshowFilterModal(!showFilterModal);
    }

 
	const [selectedServiceRequestStatusList,setSelectedServiceRequestStatusList,] = useState([]);

	const [serviceRequestStatusList, setServiceRequestStatusList] = useState([]);

    const [showCancellationReasonModal,setShowCancellationReasonModal,] = useState(false);
	const toggleCancellationReasonModal = () => {
		setShowCancellationReasonModal(!showCancellationReasonModal);
	};
	const [cancellationReasonDropdownOptions,setCancellationReasonDropdownOptions,] = useState();
	const [selectedCancellationReason,setSelectedCancellationReason,] = useState();

	const [enableOtherDescriptionTextbox,setEnableOtherDescriptionTextbox,] = useState(false);

    const [cancellationReasonOtherDescription,setCancellationReasonOtherDescription,] = useState();
	const [enableCancelButtonFlag, setEnableCancelButtonFlag] = useState("disable");

	useEffect(() => {
		enableCancelButton();
	}, [selectedCancellationReason, cancellationReasonOtherDescription]);

    const enableCancelButton = () => {
		if (selectedCancellationReason) {
			if (selectedCancellationReason.value === "Other") {
				if (
					cancellationReasonOtherDescription &&
					cancellationReasonOtherDescription.length > 0
				) {
					setEnableCancelButtonFlag("");
				} else setEnableCancelButtonFlag("disable");
			} else setEnableCancelButtonFlag("");
		} else setEnableCancelButtonFlag("disable");
	};


	//const [isLoading, setLoading] = useState(false);




	

	 

	// const fetchUserRoleAccessReport = () => {
	// 	setIsLoading(true);
	// 	try {
	// 		api.getUserRoleAccessReport()
	// 			.then(({ data }) => {
	// 				toast(data["details"], {
	// 					autoClose: 5000,
	// 					type: toast.TYPE.SUCCESS,
	// 				});
	// 				window.open(data["generated_file"], "_self");
	// 				setIsLoading(false);
	// 			})
	// 			.catch((error) => {
	// 				setIsLoading(false);
	// 				toast(error["response"]["data"]["message"], {
	// 					autoClose: 5000,
	// 					type: toast.TYPE.ERROR,
	// 				});
	// 			});
	// 	} catch (error) {
	// 		setIsLoading(false);
	// 		toast("Server error.", {
	// 			autoClose: 5000,
	// 			type: toast.TYPE.ERROR,
	// 		});
	// 	}
	// };


    

     
	/** */
	const [serviceNameList, setServiceNameList] = useState([]);
	const [selectedServiceNameList, setSelectedServiceNameList] = useState([]);

    const [SPMStatusList, setSPMStatusList] = useState([
		{
			checked: false,
			label: "Ready for Progression",
			id: "Ready for Progression",
			code: "Ready for Progression",
		},
		{
			checked: false,
			label: "Payment Confirmed By Partner",
			id: "Payment Confirmed By Partner",
			code: "Payment Confirmed By Partner",
		},
		{
			checked: false,
			label: "Awaiting For Information/Documents",
			id: "Awaiting For Information/Documents",
			code: "Awaiting For Information/Documents",
		},		
		{
			checked: false,
			label: "Service Delivery Start",
			id: "Service Delivery Start",
			code: "Service Delivery Start",
		},
		{
			checked: false,
			label: "Service Deliverables Ready",
			id: "Service Deliverables Ready",
			code: "Service Deliverables Ready",
		},
		{
			checked: false,
			label: "Full Payment Requested",
			id: "Full Payment Requested",
			code: "Full Payment Requested",
		},
		{
			checked: false,
			label: "Full Payment Received",
			id: "Full Payment Received",
			code: "Full Payment Received",
		},
		{
			checked: false,
			label: "Delivered",
			id: "Delivered",
			code: "Delivered",
		},
		{
			checked: false,
			label: "Cancelled",
			id: "Cancelled",
			code: "Cancelled",
		},
	]);
	const [selectedSPMStatus, setSelectedSPMStatus] = useState([]);

	//Filter states
	const [selectedServiceStatusListForFilter1, setSelectedServiceStatusListForFilter1] = useState([]);
	const [serviceStatusNameListForFilter1, setServiceStatusNameListForFilter1] = useState([]);

    const toggleSPMStatus = (e) => {
		let temp = selectedSPMStatus;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSrStatus = SPMStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setSPMStatusList(tempSrStatus);
			setSelectedSPMStatus(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSrStatus = SPMStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setSPMStatusList(tempSrStatus);
			setSelectedSPMStatus(temp);
			// getServices(tableInstance);
		}
	};


    const [user, setUser] = useState();
	//const [tableInstance, setTableInstance] = useState(null);

	const [serviceRequests, setServiceRequests] = useState([]);
	const [newServiceRequests, setNewServiceRequests] = useState([]);
	const [backFromPartnerServiceRequests,setBackFromPartnerServiceRequests,] = useState([]);
	const [paymentReceivedServiceRequests,setPaymentReceivedServiceRequests,] = useState([]);
	const [serviceRequestsDueToday, setServiceRequestsDueToday] = useState([]);

	const [selectedService, setSelectedService] = useState();

	const [serviceRequestsOverdue, setServiceRequestsOverdue] = useState([]);

	const [selectedServiceRequest, setSelectedServiceRequest] = useState();
	const [tableData, setTableData] = useState([]);
	const [tableDataType, setTableDataType] = useState("serviceRequests");

	const [serviceRequestFilter, setServiceRequestFilter] = useState();
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingContainer, setIsLoadingContainer] = useState(false);

    
	/*Need to talk to SP*/
	const [needToTalkToSPOptions,setneedToTalkToSPOptions] = useState([
		{
			value: true,
			label: "Yes",
		},
		{
			value: false,
			label: "No",
		},
		]);
		const [
			selectedNeedToTalkToSPOption,
			setSelectedNeedToTalkToSPOption,
		] = useState({
			value: false,
			label: "No",
		});
/*End*/

	/**
	 * Catalog modal vars and callbacks
	 */

	const [allCatalogs, setAllCatalogs] = useState();

	const fetchallCatalogs = async () => {
		let { data } = await api.getCatalogueForToolsTemplates();
		setAllCatalogs(data);
	};
	const [isCatalogueModalOpen, setIsCatalogueModalOpen] = useState(false);
	const [catalogueByServiceRequest, setCatalogueByServiceRequest] = useState(
		[]
	);
	const [selectedCatalog, setSelectedCatalog] = useState();

	const toggleCatalogModal = () => {
		setIsCatalogueModalOpen(!isCatalogueModalOpen);
	};

	const fetchCatalogueByService = async (e) => {
		let { data } = await api.getCatalogueForToolsTemplates(
			e["sResourceType"]
		);
		setCatalogueByServiceRequest(data);
	};

	const showCatalogModalClick = (e) => {
		fetchCatalogueByService(e);
		toggleCatalogModal();
		setSelectedCatalog(e["sCatalogueId"]);
	};

	/*Service Filter logic change states*/
	const [serviceNameListForFilter, setServiceNameListForFilter] = useState([]);
	const [selectedServiceNameListForFilter, setSelectedServiceNameListForFilter] = useState([]);
	/*Service Filter logic change states end*/

	/*Package Filter states*/
	const [packageNameListForFilter, setPackageNameListForFilter] = useState([]);
	const [selectedPackageNameListForFilter, setSelectedPackageNameListForFilter] = useState([]);
	const [servicesThroughPackageOptions,setservicesThroughPackageOptions,] = useState([
		{
			value: "all",
			label: "All",
		},
		{
			value: "yes",
			label: "Yes",
		},
		{
			value: "no",
			label: "No",
		},
	]);
	const [
		selectedServicesThroughPackageOption,
		setSelectedServicesThroughPackageOption,
	] = useState({
		value: "all",
		label: "All",
	});
	/*Package Filter States end*/

	/**
	 * user profile modal
	 */
	const [showUserProfileModal, setUserProfileModalVisibility] = useState(
		false
	);
	const [userProfileInitData, setUserProfileInitData] = useState({});
	const [userProfileEditableData, setUserProfileEditableData] = useState({});
	const [nUserId, setUserId] = useState();
	const [nResourceInstanceIdForUserProfile, setnResourceInstanceIdForUserProfile] = useState();
	const [sBusinessNameForUserProfile, setsBusinessNameForUserProfile] = useState();
	const [sSectorNameForUserProfile, setsSectorNameForUserProfile] = useState();
	const [sCurrentServiceRequestStateForUserProfile, setsCurrentServiceRequestStateForUserProfile] = useState();

	
	const [nResourceInstanceIdForFeedback, setnResourceInstanceIdForFeedback] = useState();
	const [refExternalServicePartnerEmailIDForFeedback, setrefExternalServicePartnerEmailIDForFeedback] = useState();
	const [sServiceNameForFeedback, setsServiceNameForFeedback] = useState();
	const [showServiceFeedbackModal, onSetShowServiceFeedbackModal] = useState(false);
	const toggleServiceFeedbackModal = () => {
		onSetShowServiceFeedbackModal(!showServiceFeedbackModal);
	};

	const handleOnShowFeedback = (e, origin) => {
		setnResourceInstanceIdForFeedback(origin["nResourceInstanceId"]);
		// setsServiceNameForFeedback(getServiceName(origin));	
		setsServiceNameForFeedback(origin["sResourceDisplayName"]);		
		if(origin.refExternalServicePartner&&origin.refExternalServicePartner.sServicePartnerEmail)
		{
			setrefExternalServicePartnerEmailIDForFeedback(origin.refExternalServicePartner.sServicePartnerEmail)
		}			
		toggleServiceFeedbackModal();
	};
	


	const getServiceName = (original) => {
		if (!original) return;
		const found = find(getServiceTypesMaster(), {
			sServiceCode: original.sServiceCode,
		});
		if (found) {
			return found.sServiceName;
		}
		return "";
	};

    /*Engagement filter modal*/

	const [showEngagementFiltersModal, onSetShowEngagementFiltersModal] = useState(false);
	const toggleEngagementFiltersModal = () => {
		onSetShowEngagementFiltersModal(!showEngagementFiltersModal);
	};

	const [introductoryConversationOptions,setItroductoryConversationOptions] = useState([
		{
			value: "Yes",
			label: "Yes",
		},
		{
			value: "No",
			label: "No",
		},
		]);

	const [selectedIntroductoryConversationOption,setSelectedIntroductoryConversationOption,] = useState(null);

	const [callStatusOptions,setCallStatusOptions] = useState([
		{
			value: "Connected",
			label: "Connected",
		},
		{
			value: "Not Connected",
			label: "Not Connected",
		},
		]);
		
	const [selectedCallStatusOption,setSelectedCallStatusOption,] = useState(null);

	const [StayEnagegedOptions,setStayEnagegedOptions] = useState([
		{
			value: "Yes",
			label: "Yes",
		},
		{
			value: "No",
			label: "No",
		},
		]);
	
	const [selectedStayEnagegedOption,setSelectedStayEnagegedOption,] = useState(null);
	const [userSharedChallegesGoalsOptions,setuserSharedChallegesGoalsOptions] = useState([
		{
			value: "Yes",
			label: "Yes",
		},
		{
			value: "No",
			label: "No",
		},
		]);
	
	const [selecteduserSharedChallegesGoalsOption,setSelecteduserSharedChallegesGoalsOption,] = useState(null);
    const [deAsraAbleHelpforChallegesGoalsOptions,setdeAsraAbleHelpforChallegesGoalsOptions] = useState([
		{
			value: "Yes",
			label: "Yes",
		},
		{
			value: "No",
			label: "No",
		},
		]);
	
	const [selecteddeAsraAbleHelpforChallegesGoalsOption,setSelecteddeAsraAbleHelpforChallegesGoalsOption,] = useState(null);


	//clear filter

	 //filter clear
	 const handleSearchInputChange = ({ target }) => {
		const { value } = target;
		setSearchTerm(value);
		if (searchFilter === null) {
			setFilterError(true);
		}
	};
	 const handleSearchClick = async () => {
		if(showFilterModal)
		{
			toggleFilterModal();
		}
		
		getAllToolTemplatesRequests(tableInstance);
	};

	const handleClearFilterSearchss = () => {		
		
		 
		setSelectedServiceNameListForFilter([]);
		setSelectedServiceStatusListForFilter1([]);
		setSelectedPackageNameListForFilter([]);
		 
		//setSearchTerm("");		
	 
		// setSearchFilter("");
		// setClearCount(clearCount+1);	
		// let tempserach = SearchByDropdownList.map((x) => {
        //     x.checked = false;
        //     return x;
        // });
        // setSearchByDropdownList(tempserach);
		setClearCount(clearCount+1);
		toggleFilterModal();
	};

	useEffect(() => {
		if(clearCount>0)
		{
			getAllToolTemplatesRequests(tableInstance);
		}		
	}, [clearCount]);



	const handleClearFilterSearch=()=>{

		setSelectedServiceNameListForFilter([]);
		setSelectedServiceStatusListForFilter1([]);
		setSelectedPackageNameListForFilter([]);
		 
		 
		setSearchTerm("");
		setSearchFilter(null);
		let tempserach = SearchByDropdownList.map((x) => {
            x.checked = false;
            return x;
        });
        setSearchByDropdownList(tempserach);
		setClearCount(clearCount+1);
		//toggleFilterModal();

	}
	// const onSearchClicked = () => {
	// 	getServices(tableInstance);
	// };

	// const handleClearFilterSearch = () => {
	// 	setDateFilter({
	// 		value: "dtServiceProgression",
	// 		label: "Progression On",
	// 	});
	// 	setCustomerFilterValue("");
	// 	setFromDate("");
	// 	setToDate("");
		
	// 	setSelectedServiceNameListForFilter([]);
	// 	setSelectedServiceStatusListForFilter1([]);
	// 	setSelectedPackageNameListForFilter([]);

	// 	setSelectedIntroductoryConversationOption(null);
	// 	setSelectedCallStatusOption(null);
	// 	setSelectedStayEnagegedOption(null);
	// 	setSelecteduserSharedChallegesGoalsOption(null);
	// 	setSelecteddeAsraAbleHelpforChallegesGoalsOption(null);
	// 	setClearCount(clearCount+1);
	// };


	
	

	/* End */




	const onEngagementFilterSearchClicked = () => {
		toggleEngagementFiltersModal();
		getServices(tableInstance);
	};

	const onClearEngagementFilterClicked = () => {
		setSelectedIntroductoryConversationOption(null);
		setSelectedCallStatusOption(null);
		setSelectedStayEnagegedOption(null);
		setSelecteduserSharedChallegesGoalsOption(null);
		setSelecteddeAsraAbleHelpforChallegesGoalsOption(null);
	};

	/*Engagement filter modal End*/

	useEffect(() => {
		if(clearCount>0)
		{
			getServices(tableInstance);
		}		
	}, [clearCount]);

	// useEffect(() => {
	// 	const serviceStatus = SPMStatusList.map((idx) => {
	// 		return {
	// 			label: idx.code,
	// 			value: idx.code,
	// 			id: idx.code,
	// 		};
	// 	});
	// 	setServiceStatusNameListForFilter1(serviceStatus);
	// }, []);

    
	/**
	 * user profile callbacks
	 */
	const handleOnClickUser = (e, origin) => {

		setUserId(origin["nUserId"]);
		setnResourceInstanceIdForUserProfile(origin["nResourceInstanceId"]);
		setsBusinessNameForUserProfile(origin["sBusinessName"]);
		if(origin.refExternalServicePartner&&origin.refExternalServicePartner.sServicePartnerEmail)
		{
			setrefExternalServicePartnerEmailIDForFeedback(origin.refExternalServicePartner.sServicePartnerEmail)
		}
		setsCurrentServiceRequestStateForUserProfile(origin.refCurrentState&&origin.refCurrentState.sServiceState||"");
		if(origin.refBusinessSectorNew)
		{
			setsSectorNameForUserProfile(origin.refBusinessSectorNew.sSectorName);
		}
		else
		{
			setsSectorNameForUserProfile(null);
		}
		
		toggleUserProfileModal();		
	};
	
	const toggleUserProfileModal = () => {
		// e.preventDefault();
		setUserProfileModalVisibility(!showUserProfileModal);
	};

	const handleUserProfileDataChanged = (name, value) => {
		const updated = {
			...userProfileEditableData,
			[name]: value,
		};
		setUserProfileEditableData(updated);
	};

	// eslint-disable-next-line no-unused-vars
	const handleSaveUserProfileData = async () => {
		//make api call to save details.
		const { sNEFTDetails } = neftDetails;
		if (sNEFTDetails && sNEFTDetails.length > 0) {
			try {
				const { nResourceInstanceId } = selectedServiceRequest;
				// eslint-disable-next-line no-unused-vars
				const { data: _ignore_ } = await api.saveNeftDetails({
					sNEFTDetails,
					bNEFTPayment: true,
					nResourceInstanceId,
				});
				toast(`NEFT details updated successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			} catch (error) {
				toast(`Something went wrong.Contact webadmin support.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			} finally {
				toggleNeftModal();
			}
		} else {
			toggleNeftModal();
		}
	};

	const createUserProfile = async () => {
		try {
		} catch (error) {}
	};

	const updateSelectedServiceRequest = (data) => {
		setSelectedServiceRequest(data);
	};

    
	/*
	 * NEFT modal data
	 */
	const [showNeftModal, setNeftModalVisibility] = useState(false);
	const [neftDetails, setNeftDetails] = useState({});

	/**
	 * NEFT callbacks
	 */
	const toggleNeftModal = (e) => {
		let user = getUser();
		if (e && e["refFacilitator"]) {
			if (
				user.access_rights["SERVICE"] &&
				user.access_rights["SERVICE"].includes("MANAGE") == false
			) {
				toast(`You are not a facilitator.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			}
			if (user.email !== e["refFacilitator"]["email"]) {
				toast("You are not the assigned facilitator.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			}
			setNeftDetails({
				bNEFTPayment: e["bNEFTPayment"],
				sNEFTDetails: e["sNEFTDetails"],
				sNEFTTxnId_2: e["sNEFTTxnId_2"],
				fAmountReceived_2: e["fAmountReceived_2"],
			});
			setSelectedServiceRequest(e);
		}
		// 		if (false) {
		// 			setSelectedServiceRequest("");
		// 			setNeftDetails({});
		// 		} else {
		// 			setNeftDetails({
		// 				bNEFTPayment: e["bNEFTPayment"],
		// 				sNEFTDetails: e["sNEFTDetails"],
		// 				sNEFTTxnId_2: e["sNEFTTxnId_2"],
		// 				fAmountReceived_2: e["fAmountReceived_2"],
		// 			});
		// 			setSelectedServiceRequest(e);
		// 		}
		setNeftModalVisibility(!showNeftModal);
	};

	const handleNeftDetailsChanged = (name, value) => {
		if (name === "sNEFTTxnId") {
			if (/^[a-z0-9]*$/i.test(value) === false) return;
			name = name.concat("_2");
		}
		if (name === "fAmountReceived") {
			if (/^[0-9]*$/i.test(value) === false) return;
			if (value === undefined || value === "") value = 0;
			name = name.concat("_2");
		}
		const updated = {
			...neftDetails,
			[name]: value,
		};
		setNeftDetails(updated);
	};

	const handleSaveNeftDetails = async () => {
		//make api call to save details.
		const {
			sNEFTDetails,
			bNEFTPayment,
			sNEFTTxnId_2,
			fAmountReceived_2 = 0,
		} = neftDetails;

		if (
			fAmountReceived_2 === 0 &&
			sNEFTTxnId_2 &&
			sNEFTDetails.length > 0
		) {
			toast(`Amount is required.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (
			fAmountReceived_2 !== 0 &&
			(sNEFTTxnId_2 === undefined || sNEFTTxnId_2 === "")
		) {
			toast(`Transaction id is required.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}

		if ((sNEFTDetails && sNEFTDetails.length > 0) || bNEFTPayment) {
			try {
				const { nResourceInstanceId } = selectedServiceRequest;
				// eslint-disable-next-line no-unused-vars
				const { data: _ignore_ } = await api.saveNeftDetailsSPM({
					sNEFTDetails,
					bNEFTPayment: true,
					sNEFTTxnId_2,
					fAmountReceived_2,
					nResourceInstanceId,
				});
				updateStatusArray(nResourceInstanceId);
				toast(`NEFT details updated successfully.`, {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			} catch (error) {
				toast(`Something went wrong. Contact webadmin support.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			} finally {
				toggleNeftModal();
			}
		} else {
			toggleNeftModal();
		}
	};

    /*
	 * Refund modal data
	 */
	const [showRefundModal, setRefundModalVisibility] = useState(false);
	const [refundDetails, setRefundDetails] = useState({});
	const [isLoadingRefund, setIsLoadingRefund] = useState(false);
	const [selectedCancellationReasonForRefund,setSelectedCancellationReasonForRefund] = useState();
	const [enableOtherDescriptionTextboxForRefund,setEnableOtherDescriptionTextboxForRefund] = useState(false);
	const [cancellationReasonOtherDescriptionforRefund,setCancellationReasonOtherDescriptionforRefund] = useState();

	/**
	 * Refund callbacks
	 */
	const toggleRefundModal = (e) => {
		let user = getUser();
		if (e && e["refFacilitator"]) {
			if (
				user.access_rights["SERVICE"] &&
				user.access_rights["SERVICE"].includes("MANAGE") == false
			) {
				toast(`You are not a facilitator.`, {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			}
			if (user.email !== e["refFacilitator"]["email"]) {
				toast("You are not the assigned facilitator.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			}
			if(e["dtRefunded"])
			{
				var dtrefund=new Date(e["dtRefunded"]);
			}
			
			setRefundDetails({
				bRefund: e["bRefund"],
				sRefundComment: e["sRefundComment"],
				dtRefunded: dtrefund,
			});
			setSelectedServiceRequest(e);
		}
		setRefundModalVisibility(!showRefundModal);
	};

	const onRefundDetailsChanged = (name, value) => 
	{		
		const updated = {...refundDetails,[name]: value};

		setRefundDetails(updated);
	};

	const onSaveRefundDetails = async () => {
		const {
			bRefund,
			sRefundComment,
			dtRefunded,
		} = refundDetails;

		if(bRefund)
		{
			if(!dtRefunded)
			{
				toast("Refund date is required", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			}

			if(!sRefundComment)
			{
				toast("Refund comment is required", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			}

			let sServiceCancellationReason=null, sServiceCancellationReasonOtherDescription=null;
			if(selectedServiceRequest["refCurrentState"]["sServiceState"] !== "Cancelled")
			{
				if (selectedCancellationReasonForRefund)
				{
					sServiceCancellationReason = selectedCancellationReasonForRefund.value;
					if (sServiceCancellationReason !== "Other")
					{
						sServiceCancellationReasonOtherDescription = null;
					}
					else
					{
						if(cancellationReasonOtherDescriptionforRefund)
						{
							sServiceCancellationReasonOtherDescription =cancellationReasonOtherDescriptionforRefund;
						}
						else
						{
							toast("Please specify cancellation reason.", {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							return;
						}
					}
				}
				else
				{
					toast("Please select cancellation reason.", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
					return;
				}
			}
			setIsLoadingRefund(true);
			const { nResourceInstanceId } = selectedServiceRequest;
			api.saveRefundDetails({
				bRefund,
				sRefundComment,
				dtRefunded:dtRefunded.toISOString(),
				nResourceInstanceId,
				sServiceCancellationReason,
				sServiceCancellationReasonOtherDescription
			})
			.then((response) => {

				if (response.status == 202)
				{
					if(response.data.message)
					{
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
					else
					{
						toast("Service updated successfully.", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
				}
				else
				{
					if(response.data.message)
					{
						toast(response.data.message, {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
					else
					{
						toast("Internal server error.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					}
				}

				getServices(tableInstance);			
				updateStatusArray(nResourceInstanceId);
				toggleRefundModal();
				setIsLoadingRefund(false);
			})
			.catch((error) => {
				toast(String(error.response.data.message), {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				setIsLoadingRefund(false);
			});
		}
		else
		{
			toast("Please select is Refunded.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
	};

	useEffect(() => {
		setSelectedCancellationReasonForRefund();
		setCancellationReasonOtherDescriptionforRefund();
		if (selectedServiceRequest && cancellationReasonDropdownOptions) {
			let temp = cancellationReasonDropdownOptions.map((e) => {
				if (e.value === selectedServiceRequest.sServiceCancellationReason) {
					setSelectedCancellationReasonForRefund(e);
					if (e.value === "Other") {
						setCancellationReasonOtherDescriptionforRefund(
							selectedServiceRequest.sServiceCancellationReasonOtherDescription
						);
					}
				}
			});
		}

	}, [selectedServiceRequest, selectedService]);

	const calculateEnableOtherDescriptionTextboxForRefund = () => {
		if (
			selectedCancellationReasonForRefund &&
			selectedCancellationReasonForRefund.value === "Other"
		)
			setEnableOtherDescriptionTextboxForRefund(true);
		else setEnableOtherDescriptionTextboxForRefund(false);
	};

	useEffect(() => {
		calculateEnableOtherDescriptionTextboxForRefund();
	}, [selectedCancellationReasonForRefund]);

    /**
	 * Notes data
	 */
	
	const [showNotesModal, setNotesModalVisibility] = useState(false);
	const [notesDetails, setNotesDetails] = useState({});
	const [notesHistory, setNotesHistory] = useState([]);
	const [currentNote, setCurrentNote] = useState({});
	const [auditTrail, setAuditTrail] = useState({});

	const [showConfirmationModal, setShowConfirmationModal] = useState(false);

	/**

	/**
	 * Notes Modal Callbacks
	 * 
	 * 
	 */

	const changeSelectedNotesDetails = (direction) => {
		if (notesHistory.length === 0) return;

		//sFollowupAction dtFollowupOn sNotes
		let currentNoteIndex;
		if (isEmpty(currentNote) == true && direction === "next") {
			setNotesDetails({
				sFollowupAction: "",
				dtFollowupOn: "",
				sNotes: "",
				bHandled: false,
				currentNoteIndex: -1,
			});
			return;
		}
		if (isEmpty(currentNote) == true && direction === "previous") {
			currentNoteIndex = notesHistory.length - 1;
			setCurrentNote(notesHistory[currentNoteIndex]);
			setNotesDetails({});
			setNotesDetails({
				currentNoteIndex: currentNoteIndex,
				sFollowupAction:
					notesHistory[currentNoteIndex]["sFollowupAction"],
				dtFollowupOn: notesHistory[currentNoteIndex]["dtFollowupOn"],
				bHandled: notesHistory[currentNoteIndex]["bHandled"],
				sNotes: notesHistory[currentNoteIndex]["sNotes"],
			});
			return;
		}
		notesHistory.map((e, i) => {
			if (currentNote["id"] === e["id"]) {
				currentNoteIndex = i;
			}
		});

		if (direction === "previous" && currentNoteIndex > 0) {
			currentNoteIndex -= 1;
			setCurrentNote(notesHistory[currentNoteIndex]);
			setNotesDetails({});
			setNotesDetails({
				currentNoteIndex: currentNoteIndex,
				sFollowupAction:
					notesHistory[currentNoteIndex]["sFollowupAction"],
				dtFollowupOn: notesHistory[currentNoteIndex]["dtFollowupOn"],
				sNotes: notesHistory[currentNoteIndex]["sNotes"],
				bHandled: notesHistory[currentNoteIndex]["bHandled"],
			});
			return;
		}
		if (
			direction === "next" &&
			currentNoteIndex < notesHistory.length - 1
		) {
			currentNoteIndex += 1;
			setCurrentNote(notesHistory[currentNoteIndex]);
			setNotesDetails({});
			setNotesDetails({
				currentNoteIndex: currentNoteIndex,
				sFollowupAction:
					notesHistory[currentNoteIndex]["sFollowupAction"],
				dtFollowupOn: notesHistory[currentNoteIndex]["dtFollowupOn"],
				sNotes: notesHistory[currentNoteIndex]["sNotes"],
				bHandled: notesHistory[currentNoteIndex]["bHandled"],
			});
			return;
		}

		if (
			direction === "next" &&
			currentNoteIndex === notesHistory.length - 1
		) {
			setCurrentNote({});
			setNotesDetails({
				sFollowupAction: "",
				dtFollowupOn: "",
				sNotes: "",
				bHandled: false,
				currentNoteIndex: -1,
			});
			return;
		}
	};

	const toggleConfirmationModalNotes = () => {
		setShowConfirmationModal(!showConfirmationModal);
	};

	const confirmChangeNotes = () => {
		setSelectedServiceRequest("");
		setNotesDetails({});
		setNotesModalVisibility(!showNotesModal);
		toggleConfirmationModalNotes();
		setCurrentNote({});

	};

//  Feedback Modal
	const [showFeedbackModal,setshowFeedbackModalVisibility]=useState(false);

	const toggleShowFeedbackModal=()=>{
		setshowFeedbackModalVisibility(!showFeedbackModal);
	}
//*//



	const toggleNotesModal = async (e) => {

		if (selectedServiceRequest) {
			if (
				notesDetails["currentNoteIndex"] !== -1 &&
				(notesDetails["dtFollowupOn"] !== currentNote["dtFollowupOn"] ||
					notesDetails["sNotes"] !== currentNote["sNotes"] ||
					notesDetails["sFollowupAction"] !==
						currentNote["sFollowupAction"] ||
					notesDetails["bHandled"] !== currentNote["bHandled"])
			) {
				if(showNotesModal === true && (notesDetails["dtFollowupOn"] !== "" || notesDetails["sNotes"] !== "" || notesDetails["sFollowupAction"] !== "" || notesDetails["bHandled"] !== false)){
					toggleConfirmationModalNotes()
				}
				else{
					setNotesModalVisibility(!showNotesModal);
				}
				return;
			} else {
				setSelectedServiceRequest("");
				setNotesDetails({});
				setCurrentNote({});
				setNotesHistory({});
				setNotesModalVisibility(!showNotesModal);
			}
		} else {
			let data = await api
				.getNotesHistory({
					nResourceInstanceId: e["nResourceInstanceId"],
				})
				.then((f) => {
					setNotesHistory(f.data);
				});

			/*let data1 = await api
				.getAuditTrailNotesSPM({
					nResourceInstanceId: e["nResourceInstanceId"],
				})
				.then((f1) => {
					setAuditTrail(f1);
				});*/
				
				let payload={nResourceInstanceId:e["nResourceInstanceId"]};
				api.getNotesfortooltemplates(payload).then(({ data }) => {
					setAuditTrail(data);
				});

				if(e.bNeedToTalkToSP)
				{
					setSelectedNeedToTalkToSPOption({
						value: true,
						label: "Yes",
					})
				}
				else
				{
					setSelectedNeedToTalkToSPOption({
						value: false,
						label: "No",
					})
				}
			setSelectedServiceRequest(e);
			setNotesModalVisibility(!showNotesModal);
		}
	};

	const onNotesChange = (name, value) => {
		const updated = {
			...notesDetails,
			[name]: value,
		};
		setNotesDetails(updated);
	};

	const onSaveNotesDetails = async () => {
		if (
			notesDetails["sNotes"] === "" ||
			notesDetails["sNotes"] === undefined ||
			notesDetails["sNotes"] === null
		) {
			toast("Notes field is mandetory", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (
			!(notesDetails["dtFollowupOn"] && notesDetails["sFollowupAction"])
		) {
			if (
				(notesDetails["sFollowupAction"] === "" ||
					notesDetails["sFollowupAction"] === null ||
					notesDetails["sFollowupAction"] === undefined) &&
				(notesDetails["dtFollowupOn"] === "" ||
					notesDetails["dtFollowupOn"] === undefined ||
					notesDetails["dtFollowupOn"] === null)
			) {
			} else if (
				notesDetails["dtFollowupOn"] === "" ||
				notesDetails["dtFollowupOn"] === undefined ||
				notesDetails["dtFollowupOn"] === null
			) {
				toast("Followup Date is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else if (
				notesDetails["sFollowupAction"] === "" ||
				notesDetails["sFollowupAction"] === undefined ||
				notesDetails["sFollowupAction"] === null
			) {
				toast("Followup Action is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else {
			}
		}

		try {

			// let bNeedToTalkToSPnew=selectedNeedToTalkToSPOption.value;	
			// const { bNeedToTalkToSP } = selectedServiceRequest;
			// if(bNeedToTalkToSPnew!=bNeedToTalkToSP)
			// {
			// 	onUpdateNeedToTalkToSPFlag();
			// }

			if (isEmpty(currentNote)) {
				let data = await api
					.saveToolsTemplatesNotes({
						...notesDetails,
						nResourceInstanceId:
							selectedServiceRequest["nResourceInstanceId"],
					})
					.then(() => {
						//setSelectedServiceRequest("");
						setNotesDetails({});
						setCurrentNote({});
						setNotesHistory({});
						//setNotesModalVisibility(false);
					});

				/*let data1 = await api
					.getAuditTrailNotesSPM({
						nResourceInstanceId:
							selectedServiceRequest["nResourceInstanceId"],
					})
					.then((f1) => {
						setAuditTrail(f1);
					});
				let data2 = await api
					.getNotesHistory({
						nResourceInstanceId:
							selectedServiceRequest["nResourceInstanceId"],
					})
					.then((f) => {
						setNotesHistory(f.data);
					})
					.catch((error) => {
						toast(String(error.response.statusText), {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					});

				setNotesDetails({
					sFollowupAction: "",
					dtFollowupOn: "",
					sNotes: "",
					bHandled: false,
				});
				setCurrentNote({});*/
			} else {
				if (
					notesDetails["dtFollowupOn"] ===
						currentNote["dtFollowupOn"] &&
					notesDetails["sNotes"] === currentNote["sNotes"] &&
					notesDetails["sFollowupAction"] ===
						currentNote["sFollowupAction"] &&
					notesDetails["bHandled"] === currentNote["bHandled"]
				) {
					toast("No changes made", {
						autoClose: 5000,
						type: toast.TYPE.INFO,
					});
					return;
				}
				let data = await api
					.updateNotes({
						...notesDetails,
						id: currentNote["id"],
						nResourceInstanceId:
							selectedServiceRequest["nResourceInstanceId"],
					})
					.then((d) => {
						setNotesDetails({
							sFollowupAction: d.data["sFollowupAction"],
							dtFollowupOn: d.data["dtFollowupOn"],
							sNotes: d.data["sNotes"],
							bHandled: d.data["bHandled"],
						});
					})

					.catch((error) => {
						toast(String(error.response.statusText), {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					});
				/*let data2 = await api
					.getAuditTrailNotesSPM({
						nResourceInstanceId:
							selectedServiceRequest["nResourceInstanceId"],
					})
					.then((f1) => {
						setAuditTrail(f1);
					});*/
					let payload={nResourceInstanceId:selectedServiceRequest["nResourceInstanceId"]};
					api.getNotesfortooltemplates(payload).then(({ data }) => {
						setAuditTrail(data);
					});

				let data1 = await api
					.getNotesHistory({
						nResourceInstanceId:
							selectedServiceRequest["nResourceInstanceId"],
					})
					.then((f) => {
						setNotesHistory(f.data);
						f.data.map((e, i) => {
							if (currentNote["id"] === e["id"]) {
								setCurrentNote(e);
								setNotesDetails({
									...notesDetails,
									currentNoteIndex: i,
								});
							}
						});
					})
					.catch((error) => {
						toast(String(error.response.statusText), {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
					});
			}
			// toggleNotesModal();
			// toggleNotesModal();

			toast("Note saved successfully.", {
				autoClose: 5000,
				type: toast.TYPE.SUCCESS,
			});
		} catch (error) {
			toast(String(error.response.statusText), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

    /** Payment link API */

	const sendPaymentLinkSPM = (e) => {
		let user = getUser();
		if (
			user.access_rights["SERVICE"] &&
			user.access_rights["SERVICE"].includes("MANAGE") == false
		) {
			toast(`You are not a facilitator.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}

		if (user.email !== e["refFacilitator"]["email"]) {
			toast("You are not the assigned facilitator.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		setIsLoadingStateChange(true);

		let data = api.sendPaymentLinkSPM({nResourceInstanceId: e["nResourceInstanceId"],})
			.then((d) => {
				if (d.data.message.status_code === "0") {
					api.setFullPaymentRequested({
						nResourceInstanceId: e["nResourceInstanceId"],
					})
						.then(() => {
							toast("Payment link sent successfully", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(e["nResourceInstanceId"]);
							setIsLoadingStateChange(false);

							// window.location.reload(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});
				} else {
					toast(String(d.data.message.message), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
					setIsLoadingStateChange(false);
				}
			})
			.catch((error) => {
				toast(String(error.response.data.detail), {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				setIsLoadingStateChange(true);
			});
	};

	/**Service Partner */

	const [servicePartnerList, setServicePartnerList] = useState([]);
	const [externalServicePartnerList,setExternalServicePartnerList,] = useState([]);

	const [currentServicePartner, setCurrentServicePartner] = useState();
	const [currentExternalServicePartner,setCurrentExternalServicePartner,] = useState();

	const [showServicePartnerModal, setShowServicePartnerModal] = useState(false);

	const [showExternalServicePartnerModal,setShowExternalServicePartnerModal,] = useState(false);

	const toggleServicePartnerModal = (e) => {
		if (selectedServiceRequest) {
			setSelectedServiceRequest("");
			setCurrentServicePartner("");
			let temp = servicePartnerList.map((f) => {
				f["checked"] = false;
				return f;
			});
			setServicePartnerList(temp);
		} else {
			setSelectedServiceRequest(e);
			setCurrentServicePartner(
				e["refServicePartner"]
					? e["refServicePartner"]["email"]
					: e["refServicePartner"]
			);
			if (e["refServicePartner"]) {
				let temp = servicePartnerList.map((f) => {
					if (f["id"] === e["refServicePartner"]["email"]) {
						f["checked"] = true;
					} else {
						f["checked"] = false;
					}
					return f;
				});
				setServicePartnerList(temp);
			}
		}

		setShowServicePartnerModal(!showServicePartnerModal);
	};

	const toggleExternalServicePartnerModal = (e) => {
		let externalSP;
		if (e) {
			setIsLoading(true);
			let temp = api
				.getExternalServicePartners({
					sServiceCode: e["sServiceCode"],
				})
				.then((d) => {
					let externalServicePartners = d.data.map((f) => {
						let flag = false;

						if (
							e["refExternalServicePartner"] &&
							f["sName"] ===
								e["refExternalServicePartner"][
									"sName"
								]
						) {
							flag = true;
						} else {
							flag = false;
						}

						return {
							checked: flag,
							label: f["sName"],
							id: f["sServicePartnerEmail"],
							code: f["sServicePartnerEmail"],
							uniqueId: f["id"]
						};
					});
					setExternalServicePartnerList(externalServicePartners);
					setIsLoading(false);
				});
		}

		if (selectedServiceRequest) {
			setSelectedServiceRequest("");
			setCurrentExternalServicePartner("");
			let temp = externalServicePartnerList.map((f) => {
				f["checked"] = false;
				return f;
			});
			setExternalServicePartnerList(temp);
		} else {
			setSelectedServiceRequest(e);
			setCurrentExternalServicePartner(
				e["refExternalServicePartner"]
					? e["refExternalServicePartner"]["sServicePartnerEmail"]
					: e["refExternalServicePartner"]
			);

			if (e["refExternalServicePartner"]) {
				let temp = externalServicePartnerList.map((f) => {
					if (
						f["id"] ===
						e["refExternalServicePartner"]["sServicePartnerEmail"]
					) {
						f["checked"] = true;
					} else {
						f["checked"] = false;
					}
					return f;
				});
				setExternalServicePartnerList(temp);
			}
		}
		setShowExternalServicePartnerModal(!showExternalServicePartnerModal);
	};

	const toggleServicePartner = (servicePartnerEmail) => {
		let temp = servicePartnerList.map((f) => {
			if (f["id"] === servicePartnerEmail) {
				f["checked"] = true;
			} else {
				f["checked"] = false;
			}
			return f;
		});
		setServicePartnerList(temp);
	};

	const toggleExternalServicePartner = (externalServicePartnerEmail) => {
		
		let temp = externalServicePartnerList.map((f) => {
			if (f["uniqueId"] == externalServicePartnerEmail) {
				f["checked"] = true;
			} else {
				f["checked"] = false;
			}
			return f;
		});
		setExternalServicePartnerList(temp);
	};

	const saveServicePartner = (e, clear = false) => {
		let user = getUser();
		if (
			user.access_rights["SERVICE"] &&
			user.access_rights["SERVICE"].includes("MANAGE") == false
		) {
			toast(`You are not a facilitator.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		let sp;
		let nResourceInstanceId;
		if (clear) {
			sp = "";
			nResourceInstanceId = e["nResourceInstanceId"];
		} else {
			sp = servicePartnerList.filter((e) => e.checked === true)[0]["id"];
			nResourceInstanceId = selectedServiceRequest["nResourceInstanceId"];
		}

		try {
			let temp = api
				.saveServicePartner({
					nResourceInstanceId: nResourceInstanceId,
					ServicePartner: sp,
				})
				.then(() => {
					if (clear === false) toggleServicePartnerModal();
					setSelectedServiceRequest("");
					setCurrentServicePartner("");
					getServices(tableInstance);

					// window.location.reload(false);
					if (clear) {
						toast("Service Partner cleared successfully.", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					} else {
						toast("Service Partner saved successfully.", {
							autoClose: 5000,
							type: toast.TYPE.SUCCESS,
						});
					}
				});
		} catch (error) {
			toast(String(error.response.data.detail), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const saveExternalServicePartner = (e, clear = false) => {
		let user = getUser();
		if (
			user.access_rights["SERVICE"] &&
			user.access_rights["SERVICE"].includes("MANAGE") == false
		) {
			toast(`You are not a facilitator.`, {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		let sp;
		let nResourceInstanceId;

		if (clear) {
			sp = "";
			nResourceInstanceId = e["nResourceInstanceId"];
		} else {
			sp = externalServicePartnerList.filter(
				(e) => e.checked === true
			)[0]["label"];
			nResourceInstanceId = selectedServiceRequest["nResourceInstanceId"];
		}

		try {
			let temp = api
				.saveServicePartner({
					nResourceInstanceId: nResourceInstanceId,
					ExternalServicePartner: sp,
				})
				.then((d) => {
					if (clear === true) {
						toast(
							"External Service Partner cleared successfully.",
							{
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							}
						);
					} else {
						toast(
							"External Service Partner assigned successfully.",
							{
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							}
						);
					}

					if (clear === false) toggleExternalServicePartnerModal();
					setSelectedServiceRequest("");
					setCurrentExternalServicePartner("");
					getServices(tableInstance);
					// window.location.reload(false);
				})
				.catch((error) => {
					toast(String(error.message), {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			toast(String(error.response.data.detail), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

    
	/**
	 * Status changes
	 */
	const [statusList, setStatusList] = useState([
		"Ready For Progression",
		"Payment Confirmed By Partner",
		"Awaiting For Information/Documents",
		"Service Delivery Start",
		"Service Deliverables ready",
		"Full Payment Requested",
		"Full Payment Received",
		"Delivered",
		"Cancelled",
	]);

	const updateStatusArray = async (instance_id) => {
		try {
			const { data } = await api.searchServiceById(instance_id);
			let temp = createStatusArray(data);
			setSelectedServiceRequest(temp);
		} catch (err) {
			console.log("Error in updating Status Array", err);
		}
	};

	const [isLoadingStateChange, setIsLoadingStateChange] = useState(false);

	const chanegState = (statusObj) => {
		let data = {
			nResourceInstanceId: statusObj["service"]["nResourceInstanceId"],
		};

		let user = getUser();
		setIsLoadingStateChange(true);
		try {
			switch (statusObj["statusName"]) {
				case "serviceDeliveryStarted":
					if (!statusObj["service"]["refServicePartner"]) {
						setIsLoadingStateChange(false);
						toast("Service Partner not assigned.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						statusObj["service"]["refServicePartner"]["email"]
					) {
						setIsLoadingStateChange(false);
						toast("You are not the assigned service partner.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["DELIVER"] ==
							false
					) {
						setIsLoadingStateChange(false);
						toast("You are not a service partner.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setServiceDeliveryStarted(data)
						.then((d) => {
							getServices(tableInstance);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							setIsLoadingStateChange(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "paymentConfirmedByPartner":
				api.setPaymentConfirmedbyPartner(data)
					.then((response) => {
						getServices(tableInstance);

						if (response.status == 202)
						{
							if(response.data.message)
							{
								toast(response.data.message, {
									autoClose: 5000,
									type: toast.TYPE.SUCCESS,
								});
							}
							else
							{
								toast("Service updated successfully.", {
									autoClose: 5000,
									type: toast.TYPE.SUCCESS,
								});
							}
						}
						else
						{
							if(response.data.message)
							{
								toast(response.data.message, {
									autoClose: 5000,
									type: toast.TYPE.ERROR,
								});
							}
							else
							{
								toast("Internal server error.", {
									autoClose: 5000,
									type: toast.TYPE.ERROR,
								});
							}
						}
						updateStatusArray(
							statusObj["service"]["nResourceInstanceId"]
						);
						setIsLoadingStateChange(false);
					})
					.catch((error) => {
						toast(String(error.response.data.message), {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						setIsLoadingStateChange(false);
					});

				break;
				case "AwaitingForInformationDocuments":
				api.setAwaitingForInformationDocuments(data)
					.then((response) => {
						getServices(tableInstance);
						if (response.status == 202)
						{
							if(response.data.message)
							{
								toast(response.data.message, {
									autoClose: 5000,
									type: toast.TYPE.SUCCESS,
								});
							}
							else
							{
								toast("Service updated successfully.", {
									autoClose: 5000,
									type: toast.TYPE.SUCCESS,
								});
							}
						}
						else
						{
							if(response.data.message)
							{
								toast(response.data.message, {
									autoClose: 5000,
									type: toast.TYPE.ERROR,
								});
							}
							else
							{
								toast("Internal server error.", {
									autoClose: 5000,
									type: toast.TYPE.ERROR,
								});
							}
						}
						updateStatusArray(
							statusObj["service"]["nResourceInstanceId"]
						);
						setIsLoadingStateChange(false);
					})
					.catch((error) => {
						toast(String(error.response.data.message), {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						setIsLoadingStateChange(false);
					});

				break;
				case "serviceDeliverablesReady":
					if (!statusObj["service"]["refServicePartner"]) {
						toast("Service Partner not assigned", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						statusObj["service"]["refServicePartner"]["email"]
					) {
						toast("You are not the assigned service partner", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["DELIVER"] ==
							false
					) {
						toast("You are not a service partner", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setServiceDeliverablesReady(data)
						.then((d) => {
							getServices(tableInstance);
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							setIsLoadingStateChange(false);

							// let temp = createStatusArray(d.data);
							// console.log("selected service changed to", temp);
							// setSelectedService(temp);
							// window.location.reload(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "requestFullPayments":
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["MANAGE"] ==
							false
					) {
						toast("You are not a facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						statusObj["service"]["refFacilitator"]["email"]
					) {
						toast("You are not the assigned facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setFullPaymentRequested(data)
						.then((d) => {
							getServices(tableInstance);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							setIsLoadingStateChange(false);

							// setSelectedService(d.data);
							// document.location.reload(true);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "fullPaymentReceived":
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["MANAGE"] ==
							false
					) {
						toast("You are not a facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						statusObj["service"]["refFacilitator"]["email"]
					) {
						toast("You are not the assigned facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setFullPaymentComplete(data)
						.then((d) => {
							getServices(tableInstance);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							setIsLoadingStateChange(false);

							// setSelectedService(d.data);
							// document.location.reload(true);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "delivered":
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["MANAGE"] ==
							false
					) {
						toast("You are not a facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						statusObj["service"]["refFacilitator"]["email"]
					) {
						toast("You are not the assigned facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setServiceDelivered(data)
						.then((d) => {
							getServices(tableInstance);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							setIsLoadingStateChange(false);

							// setSelectedService(d.data);
							// window.location.reload(true);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "cancelled":
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["MANAGE"] ==
							false
					) {
						toast("You are not a facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						statusObj["service"]["refFacilitator"]["email"]
					) {
						toast("You are not the assigned facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						statusObj["service"]["refCurrentState"][
							"sServiceState"
						] === "Delivered"
					) {
						toast("A delivered service can not be cancelled", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					let cancellation_Reason, OtherDescription;
					if (selectedCancellationReason) {
						cancellation_Reason = selectedCancellationReason.value;
						if (cancellation_Reason !== "Other")
							OtherDescription = null;
						else
							OtherDescription = cancellationReasonOtherDescription;
					}

					api.setServiceCancelled({
						...data,
						cancellationReason: cancellation_Reason,
						cancellationReasonOtherDescription: OtherDescription,
					})
						.then((d) => {
							getServices(tableInstance);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								statusObj["service"]["nResourceInstanceId"]
							);
							toggleCancellationReasonModal();
							setIsLoadingStateChange(false);

							// setSelectedService(d.data);
							// window.location.reload(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				default:
					break;
			}

			// console.log("data === >", data);
			// toast("Status changed successfully.", {
			//   autoClose: 5000,
			//   type: toast.TYPE.SUCCESS,
			// });
		} catch (error) {
			toast(String(error.response.data.message), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	/**
	 * pagination states
	 */
	const [pages, setPages] = useState(0);
	const [pageSize, setPageSize] = useState(10);
	const [currentPage, setcurrentPage] = useState(0);
	const [tableInstance, setTableInstance] = useState(null);
	const history = useHistory();
	//const [count, setCount ] = useState(0);
	const [filterError, setFilterError] = useState(false);
	const [searchTerm, setSearchTerm] = useState("");
	const [searchFilter, setSearchFilter] = useState(null);
	const [pageSizeOptions,setpageSizeOptions] = useState([
        {
            value: "10",
            label: "10 Rows",
        },
        {
            value: "20",
            label: "20 Rows",
        },
        {
            value: "30",
            label: "30 Rows",
        },
        {
            value: "50",
            label: "50 Rows",
        },
        {
            value: "75",
            label: "75 Rows",
        },
        {
            value: "100",
            label: "100 Rows",
        },
    ]);
    const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
        value: "10",
        label: "10",
    });


	useEffect(() => {
        getAllToolTemplatesRequests(tableInstance, true);
        setSelectedServiceRequest("");        
	}, [selectedPageSizeOption]);




	const createStatusArray = (d) => {
		let tempStatusArray = [];
		if (statusList.indexOf(d["refCurrentState"]["sServiceState"]) >= 0)
		{
			for (let i = 0; i < 9; i++)
			{
				if (d["refCurrentState"]["sServiceState"] === "Cancelled")
				{
					tempStatusArray.push("disable");
				}
				else
				{
					if (i <=statusList.indexOf(d["refCurrentState"]["sServiceState"]))
					{
						tempStatusArray.push("status-reached");
					}
					else if (i ==statusList.indexOf(d["refCurrentState"]["sServiceState"]) +1)
					{
						tempStatusArray.push("");
					}
					else
					{
						tempStatusArray.push("disable");
					}
				}
			}
			if (d["sPaymentMode"] === "1_Step_Payment")
			{	
				tempStatusArray[5] = "disable";
				tempStatusArray[6] = "disable";
				if (d["refCurrentState"]["sServiceState"] ==="Service Deliverables ready")
					tempStatusArray[7] = "";
			}

			if (d["sPaymentMode"] === "No_Payment")
			{
				tempStatusArray[5] = "disable";
				tempStatusArray[6] = "disable";
				if (d["refCurrentState"]["sServiceState"] ==="Service Deliverables ready")
					tempStatusArray[7] = "";
			}

			tempStatusArray[8] = "";
			if (d["refCurrentState"]["sServiceState"] === "Delivered")
			{
				tempStatusArray[8] = "disable";
			}

			if (d["refCurrentState"]["sServiceState"] === "Cancelled")
			{
				tempStatusArray[8] = "status-reached";
			}

			if(d["sPaymentMode"] === "SP_paid_service")
			{
				if(d["refCurrentState"]["sServiceState"]==="Ready For Progression")
				{
					tempStatusArray[1]="";
				}
				else
				{
					tempStatusArray[1]="status-reached";
				}
			}
			else
			{
				tempStatusArray[1]="disable";
				if(d["refCurrentState"]["sServiceState"]==="Ready For Progression")
				{
					tempStatusArray[2]="";
				}
			}

			if (d["refCurrentState"]["sServiceState"] === "Cancelled")
			{
				tempStatusArray[0] ="disable";
				tempStatusArray[1] ="disable";
				tempStatusArray[2] ="disable";
				tempStatusArray[3] ="disable";
				tempStatusArray[4] ="disable";
				tempStatusArray[5] ="disable";
				tempStatusArray[6] ="disable";
				tempStatusArray[7] ="disable";
				tempStatusArray[8] = "status-reached";
			}

			if(d["nPackageInstanceId"])
			{
				tempStatusArray[1] ="disable";
				tempStatusArray[5] ="disable";
				tempStatusArray[6] ="disable";

				if(d["refCurrentState"]["sServiceState"]==="Ready For Progression"||
				d["refCurrentState"]["sServiceState"]==="Payment Confirmed By Partner")
				{
					tempStatusArray[2]="";
				}

				if (d["refCurrentState"]["sServiceState"] ==="Service Deliverables ready")
				{
					tempStatusArray[7] = "";
				}
			}

			if (d["bCouponApplied"]&&(d["fAmountSecond"]<=d["fDiscountAmount"]))
			{
				tempStatusArray[5] = "disable";
				tempStatusArray[6] = "disable";
				if (d["refCurrentState"]["sServiceState"] ==="Service Deliverables ready")
				{
					tempStatusArray[7] = "";
				}
			}
		}
		d["statusArray"] = tempStatusArray;

		return d;
	};

	const onSearchClicked = () => {
		getAllToolTemplatesRequests(tableInstance); 
	};

	// const onClearAllClicked = () => {
	// 	setDateFilter({
	// 		value: "dtServiceProgression",
	// 		label: "Progression On",
	// 	});
	// 	setCustomerFilterValue("");
		 
		
	// 	setSelectedServiceNameListForFilter([]);
	// 	setSelectedServiceStatusListForFilter1([]);
	// 	setSelectedPackageNameListForFilter([]);


	// 	setSearchTerm("");
	// 	setSearchFilter(null);
	// 	let tempserach = SearchByDropdownList.map((x) => {
    //         x.checked = false;
    //         return x;
    //     });
    //     setSearchByDropdownList(tempserach);

	// 	setSelectedIntroductoryConversationOption(null);
	// 	setSelectedCallStatusOption(null);
	// 	setSelectedStayEnagegedOption(null);
	// 	setSelecteduserSharedChallegesGoalsOption(null);
	// 	setSelecteddeAsraAbleHelpforChallegesGoalsOption(null);
	// 	setClearCount(clearCount+1);
	// };



	// const handleClearFilterSearch = () => {
         
	// 	setSearchTerm("");
	// 	setSearchFilter(null);
	// 	let tempserach = SearchByDropdownList.map((x) => {
    //         x.checked = false;
    //         return x;
    //     });
    //     setSearchByDropdownList(tempserach);
	// 	setClearCount(clearCount+1);
	// 	//getAllServiceRequests(tableInstance);
	// };



	const [customerFilterOptions, setCustomerFilterOptions] = useState([
		{
			value: "C_name",
			label: "Customer Name",
		},
		{
			value: "C_email",
			label: "Customer Email",
		},
	]);

	const [customerFilter, setCustomerFilter] = useState();

	const onCustomerFilterChange = (e) => {
		setCustomerFilter(e);
	};

	const [customerFilterValue, setCustomerFilterValue] = useState();
	const onCustomerFilterValueChange = (e) => {
		setCustomerFilterValue(e.target.value);
	};

	const [showSendNeftDetailsModal, onSetShowSendNeftDetailsModal] = useState(false);

	const [neftPaymentDetails, onSetNeftPaymentDetails] = useState({});

	const [nResourceInstanceId, setnResourceInstanceId] = useState();
	//const [isLoadingSpinnerForMyProgression, setIsLoadingSpinnerForMyProgression] = useState(true);
	const [isLoadingSpinnerForMyResourceAssignment,setIsLoadingSpinnerForMyResourceAssignment]=useState(true);
	

	const setShowSendNeftDetailsModal = (data, nResourceInstanceId) => {
		onSetShowSendNeftDetailsModal(data);
		setnResourceInstanceId(nResourceInstanceId);
		if (data) {
			api.getNeftAccountDetails().then(({ data }) => {
				onSetNeftPaymentDetails(data);
			});
		}
	};

	const onClickSendNeftAccountDetails = () => {
		api.sendNeftAccountDetails({
			sEmailAddress: selectedServiceRequest["sEmailAddress"],
			nResourceInstanceId: nResourceInstanceId
		})
			.then(({ data }) => {
				onSetShowSendNeftDetailsModal(false);
				toast(data["details"], {
					autoClose: 3000,
					type: toast.TYPE.SUCCESS,
				});
			})
			.catch((e) => {
				onSetShowSendNeftDetailsModal(true);
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 3000,
					type: toast.TYPE.ERROR,
				});
			});
	};

    // const getServices = (instance, flag) => {
	// 	getAllToolTemplatesRequests(instance, flag);
	// };



	//Know More DropDown

	const [isSearchByDropdownOpens, setisSearchByDropdownOpens] = useState(false);
	const [selectedServiceForKnowMore, setSelectedServiceForKnowMore] = useState(null);

	const onKnowMoreClick=(original)=>{
		setSelectedServiceForKnowMore(original);
        togglesSearchByVisibility();
    }


    const togglesSearchByVisibility=()=>{
        setisSearchByDropdownOpens(!isSearchByDropdownOpens);
    }

	//const ColumnDropdownRef = useRef();
	const SearchsDropdownRef = useRef();
	useEffect(() => {
		const interval = setInterval(() => 
		{
			if (isSearchByDropdownOpens) 
			{
			  document.addEventListener("click", Close);
			} 
			else 
			{
			  document.removeEventListener("click", Close);
			}

		}, 0);
		return () => {
			clearInterval(interval)
			document.removeEventListener("click", Close);
		};
	});

	const Close = (e) => {
		 
	    if(isSearchByDropdownOpens)
		{
			if (SearchsDropdownRef.current && SearchsDropdownRef.current.contains(e.target)) 
			{
				return;
			}
			togglesSearchByVisibility();
			setSelectedServiceForKnowMore(null);
		}		
	};

	
	








    let SearchByOptions=[
		// {
		// 	checked: false,
		// 	label: "Handholder",
		// 	id: "Handholders",
        //     code: "Handholders",
		// },
        {
			checked: false,
			label: "Service Instance ID",
			id: "Service Instance ID",
            code: "ServiceInstanceID",
		},
        {
			checked: false,
			label: "Package/Program Instance ID",
			id: "Package/Program Instance ID",
            code: "PackageProgramInstanceID",
		},
        {
			checked: false,
			label: "Customer Email ID",
			id: "Customer Email ID",
            code: "CustomerEmailID",
		},
        
        {
			checked: false,
			label: "Phone Number",
			id: "Phone Number",
            code: "PhoneNumber",
		}
	];
    const [count, setCount ] = useState(0);
     

	const [SearchByDropdownList, setSearchByDropdownList] = useState(SearchByOptions);
    const [isSearchByDropdownOpen, setisSearchByDropdownOpen] = useState(false);
    const toggleSearchByVisibility=()=>{
        setisSearchByDropdownOpen(!isSearchByDropdownOpen);
    }

	 
	const SearchDropdownRef = useRef();
	useEffect(() => {
		const interval = setInterval(() => 
		{
			if (isSearchByDropdownOpen) 
			{
			  document.addEventListener("click", close);
			} 
			else 
			{
			  document.removeEventListener("click", close);
			}

		}, 0);
		return () => {
			clearInterval(interval)
			document.removeEventListener("click", close);
		};
	});

	const close = (e) => {
		 
	    if(isSearchByDropdownOpen)
		{
			if (SearchDropdownRef.current && SearchDropdownRef.current.contains(e.target)) 
			{
				return;
			}
			toggleSearchByVisibility();
		}		
	};

	const selectSearchBySelection = (e) => {
		let temp = SearchByDropdownList;
		let tempserach = SearchByDropdownList.map((x) => {
            if (x.code == e) {
                x.checked = !x.checked;
            }
			else
			{
				x.checked = false;
			}
            return x;
        });
        setSearchByDropdownList(tempserach);
	};





    const getAllToolTemplatesRequests = async (instance, flag = false) => {
		if (!instance) return;
		
		if (!tableInstance) setTableInstance(instance);
		try 
        {
			const { page } = instance.state ?? { page: 0 };
			let icurrentPage=page;
			if (!flag &&isNaN(icurrentPage)) return;
			const pageSize =selectedPageSizeOption.value;

			if(flag || isNaN(icurrentPage))
			{
				icurrentPage=0;
			}

			let filterParameters = {
				page:icurrentPage+1,
				page_size:pageSize,
				pagination:true,
			};

			if(currentPage!=icurrentPage)
			{
				setSelectedServiceRequest([]);
			}
			console.log("Search Clicked="+searchTerm);
			SearchByDropdownList.map((x) => {
				if (x.checked && searchTerm)
				{
					
					// if(x.code==="Handholders")
					// {
					// 	filterParameters.HH_email= searchTerm ;
					// }
					if(x.code==="ServiceInstanceID")
					{
						filterParameters.nResourceInstanceId=searchTerm ;
					}
					else if(x.code==="PackageProgramInstanceID")
					{
						filterParameters.nPackageInstanceId=searchTerm;
					}
					else if(x.code==="CustomerEmailID")
					{
						filterParameters.C_email=searchTerm;
					}
					else if(x.code==="PhoneNumber")
					{
						filterParameters.C_phone=searchTerm ;
					}
				}
			});

			let resourceIdstemp = [];
			selectedServiceStatusListForFilter1.map((e) => {
				resourceIdstemp.push(e.value);
			});
			//const selectedToolsList=selectedToolsListTemp

			//let selectedTemplatesListTemp = [];
			selectedPackageNameListForFilter.map((e) => {
				resourceIdstemp.push(e.value);
			});
			const selectedResourceIDs=resourceIdstemp

			if(selectedResourceIDs.length)
			{
				let sResIDs = "";
				for (var i = 0; i < selectedResourceIDs.length; i++) {
					sResIDs += selectedResourceIDs[i]+",";
				}
				filterParameters.sResourceIDs = sResIDs;
			}
			 
			const serializedState = localStorage.getItem("USER_DETAILS");
			let a = JSON.parse(serializedState)
			filterParameters.userEmail = a.email;
			setIsLoading(true);
			
			api.getToolTemplatesRequests(filterParameters).then(({ data }) => {
				setIsLoading(false);
				if(data)
				{
					const { results, count } = data;
					setcurrentPage(icurrentPage);
					const totalPages = (count - 1) / pageSize + 1;                    
					setCount(count);
					setPages(Math.floor(totalPages));
					setPageSize(pageSize);
					setServiceRequests(results);
				}
				else
				{
					toast("", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				}
			});

			 	
			setIsLoadingContainer(false);

		} catch (error) 
        {
			console.error(error);
		}
	};

	const getServices = (instance,flag = null) => {
		if (!instance) return;
		if (!tableInstance) setTableInstance(instance);
		if (!getUser()) {
			history.push("/login");
		}
		//fetchallCatalogs();
		setUser(getUser());
		setTableDataType("serviceRequests");
	
		const { page } = instance.state ?? { page: 0 };
            let icurrentPage=page;
            if (!flag &&isNaN(icurrentPage)) return;
            const pageSize =selectedPageSizeOption.value;

            if(flag || isNaN(icurrentPage))
            {
                icurrentPage=0;
            }


			api.getToolsTemplatesTool().then(({ data }) => {

				const ToolsList = Object.keys(data).map((idx) => {
					return {
						label: data[idx].sResourceName,
						id: data[idx].sResourceID,
						value: data[idx].sResourceID,
					};
				});
				setServiceStatusNameListForFilter1(ToolsList);
			});
	
	
			api.getToolsTemplatesTemplate().then(({ data }) => 
			{
				const packageNamesForFilter = Object.keys(data).map((idx) => {
					return {
						label: data[idx].sResourceName,
						id: data[idx].sResourceID,
						value: data[idx].sResourceID,
					};
				});
				setPackageNameListForFilter(packageNamesForFilter);
			});


			api.getToolsTemplatesTool({
				bDisableService:false
			}).then(({ data }) => {
				const serviceReqNames = Object.keys(data).map((idx) => {
					return {
						checked: selectedServiceNameList.includes(
							data[idx].sServiceCode
						),
						label: data[idx].sServiceName,
						id: data[idx].id,
						code: data[idx].sServiceCode,
					};
				});
				setServiceNameList(serviceReqNames);
				const serviceReqNamesForFilter = Object.keys(data).map((idx) => {
					return {
						label: data[idx].sServiceName,
						id: data[idx].id,
						value: data[idx].sServiceCode,
					};
				});
				setServiceNameListForFilter(serviceReqNamesForFilter);
			});



		setIsLoadingContainer(true);
		//setIsLoadingSpinnerForMyProgression(true);
		setIsLoadingSpinnerForMyResourceAssignment(true);

		api.getMyResourceToolsTemplates(
			icurrentPage+1,
			pageSize,
			customerFilterValue,
			customerFilter,
		).then(({ data }) => {
			let count = data.count;
			setcurrentPage(icurrentPage);
			const totalPages = (count - 1) / pageSize + 1;	 
			setPages(Math.floor(totalPages));
			setPageSize(pageSize);
			let temp = statusList.map((status) => {
				data.results.map((d) => {});
			});

		});		
		setIsLoadingContainer(false);
		//setIsLoadingSpinnerForMyProgression(false);
		setIsLoadingSpinnerForMyResourceAssignment(false);
	};

	// useEffect(() => {
		/**
		 * fetch master list of all handholders in the system
		 */
		 
		//  api.getToolsTemplatesTool().then(({ data }) => {
		// 	const serviceReqStatus = Object.keys(data).map((idx) => {
		// 		return {
		// 			checked: selectedServiceRequestStatusList.includes(
		// 				data[idx].id
		// 			),
		// 			label: data[idx].sResourceName,
		// 			id: data[idx].sResourceIDs,
		// 			code: data[idx].sResourceIDs,
		// 		};
		// 	});
		// 	setServiceRequestStatusList(serviceReqStatus);

		// 	const serviceStatus = Object.keys(data).map((idx) => {
		// 		return {
		// 			label: data[idx].sResourceName,
		// 			id: data[idx].sResourceIDs,
		// 			code: data[idx].sResourceIDs,
		// 		};
		// 	});
		// 	setServiceStatusNameListForFilter1(serviceStatus);
		// });

	// 	api.getToolsTemplatesTemplate().then(({ data }) => 
	// 	{
	// 		const packageNamesForFilter = Object.keys(data).map((idx) => {
	// 			return {
	// 				label: data[idx].sResourceName,
	// 				id: data[idx].sResourceIDs,
	// 				value: data[idx].sResourceIDs,
	// 			};
	// 		});
	// 		setPackageNameListForFilter(packageNamesForFilter);
	// 	});
		 
	// });

	// const fetchServiceRequests = (instance, flag) => {
	// 	getAllServiceRequests(instance, flag);
	// };

	/**Date range */
	const [fromDate, setFromDate] = useState();
	const [toDate, setToDate] = useState();
	const [dateRangeOption, setDateRangeOptions] = useState([
		{
			value: "dtServiceProgression",
			label: "Progression On",
		},
		{
			value: "dtLastFacilitatorAssigned",
			label: "Facilitator Assigned On"
		}
	]);

	const onDateRangeChange = (dateLable, dateValue) => {
		if (dateLable === "fromDate") {
			setFromDate(dateValue);
		}
		if (dateLable === "toDate") {
			setToDate(dateValue);
		}
	};

	const [dateFilter, setDateFilter] = useState({
		value: "dtServiceProgression",
		label: "Progression On",
	});

	const onDateFilterChange = (e) => {
		setDateFilter(e);
	};
	/**State audit log */
	const [stateAuditLog, setStateAuditLog] = useState();

	useEffect(() => {
		if (selectedServiceRequest) {
			api.getStateAuditLogSPM(
				selectedServiceRequest["nResourceInstanceId"]
			).then((d) => {
				setStateAuditLog(d.data);
			});
		}
	}, [selectedServiceRequest]);

	const calculateEnableOtherDescriptionTextbox = () => {
		if (
			selectedCancellationReason &&
			selectedCancellationReason.value === "Other"
		)
			setEnableOtherDescriptionTextbox(true);
		else setEnableOtherDescriptionTextbox(false);
	};

	useEffect(() => {
		calculateEnableOtherDescriptionTextbox();
	}, [selectedCancellationReason]);

	useEffect(() => {
		setSelectedCancellationReason();
		setCancellationReasonOtherDescription();
		if (selectedServiceRequest && cancellationReasonDropdownOptions) {
			let temp = cancellationReasonDropdownOptions.map((e) => {
				if (e.value === selectedServiceRequest.sServiceCancellationReason) {
					setSelectedCancellationReason(e);
					if (e.value === "Other") {
						setCancellationReasonOtherDescription(
							selectedServiceRequest.sServiceCancellationReasonOtherDescription
						);
					}
				}
			});
		}

		// setSelectedCancellationReason();
	}, [selectedServiceRequest, selectedService]);

	useEffect(() => {
		const { temp } = api.getCancellationReasons().then(({ data }) => {
			let temp1 = data.map((e) => {
				return { value: e.sReason, label: e.sReason };
			});
			setCancellationReasonDropdownOptions(temp1);
		});
	}, []);

	useDebouncedEffect(
		() => {
			getServices(tableInstance);
		},
		2000,
		[
			// fromDate,
			// toDate,
			// dateFilter,
			// customerFilterValue,
			// selectedSPMStatus,
			// selectedServiceNameList,
			tableInstance,
		]
	);

	/*Callbacks for service filter */
	const toggleAllForFilter = () => 
	{
		let temp =[];
		
		if (selectedServiceNameListForFilter.length != serviceNameListForFilter.length && selectedServiceNameListForFilter.length!=(serviceNameListForFilter.length+1)) 
		{
			if(selectedServiceNameListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedServiceNameListForFilter;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = serviceNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedServiceNameListForFilter(temp);
			setServiceNameListForFilter(tempSR);
			getServices(tableInstance);
		} 
		else
		{
			setSelectedServiceNameListForFilter([]);
			getServices(tableInstance);
		}
	};

	const toggleSelectionForFilter = (e) => {
		setSelectedServiceNameListForFilter(e);
	};
	/* Callbacks for service filter */

	/*Callbacks for Package filter */
	const toggleAllForPackageFilter = () => 
	{
		let temp =[];
		
		if (selectedPackageNameListForFilter.length != packageNameListForFilter.length && selectedPackageNameListForFilter.length!=(packageNameListForFilter.length+1)) 
		{
			if(selectedPackageNameListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedPackageNameListForFilter;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = packageNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedPackageNameListForFilter(temp);
			setPackageNameListForFilter(tempSR);
			getServices(tableInstance);
		} 
		else
		{
			setSelectedPackageNameListForFilter([]);
			getServices(tableInstance);
		}
	};

	const toggleSelectionForPackageFilter = (e) => {
		setSelectedPackageNameListForFilter(e);
	};
	/* Callbacks for Package filter */

	const toggleAllForServiceStatusFilter = () => 
	{
		let temp =[];
		
		if (selectedServiceStatusListForFilter1.length != serviceStatusNameListForFilter1.length && selectedServiceStatusListForFilter1.length!=(serviceStatusNameListForFilter1.length+1)) 
		{
			if(selectedServiceStatusListForFilter1.includes({label: "All", value: "*"}))
			{
				temp = selectedServiceStatusListForFilter1;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = serviceStatusNameListForFilter1.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedServiceStatusListForFilter1(temp);
			setServiceStatusNameListForFilter1(tempSR);
			//getExternalPartnerServices(tableInstance);
		} 
		else
		{
			setSelectedServiceStatusListForFilter1([]);
			//getExternalPartnerServices(tableInstance);
		}
	};

	const toggleSelectionForServiceStatusFilter = (e) => {
		setSelectedServiceStatusListForFilter1(e);
	};

	/*Need to talk to sp callback */
	const onUpdateNeedToTalkToSPFlag = async () => {		
		let bNeedToTalkToSP=selectedNeedToTalkToSPOption.value;	
		const { nResourceInstanceId } = selectedServiceRequest;
		api.updateNeedtoTalkToSPFlagSPM(nResourceInstanceId,{bNeedToTalkToSP})
		.then((response) => {
			if (response.status == 202)
			{
				setSelectedServiceRequest({...selectedServiceRequest,bNeedToTalkToSP:bNeedToTalkToSP})
				if(response.data.message)
				{
					toast(response.data.message, {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
				else
				{
					toast("Service updated successfully.", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
			}
			else
			{
				if(response.data.message)
				{
					toast(response.data.message, {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				}
				else
				{
					toast("Internal server error.", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				}
			}
			//toggleNotesModal();
			//getServices(tableInstance);				
		})
		.catch((error) => {
			toast(String(error.response.data.message), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		});	
	};
	/*end*/

	 


	//statusList for filter

    const toggleStatusSelection = (e) => {
		let temp = selectedServiceRequestStatusList;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			// getAllServiceRequests(tableInstance);
		}
	};

	 

	 


	//export to excell//

	//expand
	const [ExpandedChange, setExpandedChange] = useState({});



	return(
		<>
			<div className={`row ${isLoadingContainer && "set-opacity"}`}>
				{isLoadingContainer && <Spinner className="center-screen" />}
				{
					<>
						<MyResourceFilter
							toggleFilterModal={toggleFilterModal}
							toggleEngagementFiltersModal={toggleEngagementFiltersModal}
							onCustomerFilterValueChange={onCustomerFilterValueChange}
							onSearchClicked={onSearchClicked}
							customerFilterValue={customerFilterValue}
							onClearFilterSearch={handleClearFilterSearch}
							SearchByDropdownList={SearchByDropdownList}
							isSearchByDropdownOpen={isSearchByDropdownOpen}
							toggleSearchByVisibility={toggleSearchByVisibility}
							SearchDropdownRef={SearchDropdownRef}
							selectSearchBySelection={selectSearchBySelection}
							onSearchInputChange={handleSearchInputChange}
							data={serviceRequests}
							searchTerm={searchTerm}


							
							//csvReport={csvReport}
							//onSearchClicked={handleSearchClick}
						/>

                            <MyResourceTable
								user={getUser()}
								data={serviceRequests}
								//isLoadingSpinnerForMyProgression={isLoadingSpinnerForMyProgression}
								isLoadingSpinnerForMyResourceAssignment={isLoadingSpinnerForMyResourceAssignment}
								selectedServiceRequest={selectedServiceRequest} //{selectedServiceRequests}
								onSelectServiceRequest={setSelectedServiceRequest} //{setSelectedServiceRequests}
								onFetchServiceRequests={getAllToolTemplatesRequests} //{fetchServiceRequests}
								pages={pages}
								pageSize={pageSize}
								page={currentPage}
								pageSizeOptions={pageSizeOptions}
								selectedPageSizeOption={selectedPageSizeOption}
								onPageSizeOptionChange={(option) => {
									setSelectedPageSizeOption(option);
								}}
								stateAuditLog={stateAuditLog}
								//searchTerm={searchTerm}
								/**
								 * user profile
								 */
								
								/**
								 * NEFT Modal
								 */
								isNeftModalOpen={showNeftModal}
								toggleNeftModal={toggleNeftModal}
								neftDetails={neftDetails}
								onNeftDetailsChanged={handleNeftDetailsChanged}
								onSaveNeftDetails={handleSaveNeftDetails}
								/**Misc */
								sendPaymentLink={sendPaymentLinkSPM}
								/**
								 * Notes Modal
								 */
								auditTrail={auditTrail}
								changeSelectedNotesDetails={changeSelectedNotesDetails}
								notesHistory={notesHistory}
								notesDetails={notesDetails}
								showNotesModal={showNotesModal}
								toggleNotesModal={toggleNotesModal}
								onNotesChange={onNotesChange}
								onSaveNotesDetails={onSaveNotesDetails}
								showConfirmationModalNotes={showConfirmationModal}
								toggleConfirmationModalNotes={toggleConfirmationModalNotes}
								confirmChangeNotes={confirmChangeNotes}
								/**
								 * Service Partner Modal
								 *
								 */
								 toggleUserProfileModal={handleOnClickUser}
								/**/
								//isOpen={props.showFeedbackModal}
								// showFeedbackModal={showFeedbackModal}
                                // toggleShowFeedbackModal={toggleShowFeedbackModal}
								toggleShowFeedbackModal={handleOnShowFeedback}
								/** */
								  
				
								showServicePartnerModal={showServicePartnerModal}
								toggleServicePartnerModal={toggleServicePartnerModal}
								servicePartnerList={servicePartnerList}
								currentServicePartner={currentServicePartner}
								saveServicePartner={saveServicePartner}
								toggleServicePartner={toggleServicePartner}
								/**
								 * External Service Partner List
								 */
				
								showExternalServicePartnerModal={
									showExternalServicePartnerModal
								}
								isLoading={isLoading}
								toggleExternalServicePartnerModal={
									toggleExternalServicePartnerModal
								}
								externalServicePartnerList={externalServicePartnerList}
								currentExternalServicePartner={currentExternalServicePartner}
								saveExternalServicePartner={saveExternalServicePartner}
								toggleExternalServicePartner={toggleExternalServicePartner}
								/**
								 * Status column api calls
								 */
								isLoadingStateChange={isLoadingStateChange}
								changeState={chanegState}
								/**
								 * catalog modal
								 */
								showCatalogModalClick={showCatalogModalClick}
								allCatalogs={allCatalogs}
								/**
								 * Cancellation Modal
								 */
								enableCancelButtonFlag={enableCancelButtonFlag}
								showCancellationReasonModal={showCancellationReasonModal}
								toggleCancellationReasonModal={toggleCancellationReasonModal}
								cancellationReasonDropdownOptions={
									cancellationReasonDropdownOptions
								}
								setSelectedCancellationReason={setSelectedCancellationReason}
								selectedCancellationReason={selectedCancellationReason}
								enableOtherDescriptionTextbox={enableOtherDescriptionTextbox}
								cancellationReasonOtherDescription={
									cancellationReasonOtherDescription
								}
								onChangeCancellationReasonOtherDescription={(value) =>
									setCancellationReasonOtherDescription(value)
								}
								showSendNeftDetailsModal={showSendNeftDetailsModal}
								setShowSendNeftDetailsModal={setShowSendNeftDetailsModal}
				
								/**Refund Modal */
								isLoadingRefund={isLoadingRefund}
								isRefundModalOpen={showRefundModal}
								toggleRefundModal={toggleRefundModal}
								refundDetails={refundDetails}
								onRefundDetailsChanged={onRefundDetailsChanged}
								onSaveRefundDetails={onSaveRefundDetails}
								onSelectCancellationReasonforRefund={setSelectedCancellationReasonForRefund}
								selectedCancellationReasonforRefund={selectedCancellationReasonForRefund}
								enableOtherDescriptionTextboxforRefund={enableOtherDescriptionTextboxForRefund}
								cancellationReasonOtherDescriptionforRefund={cancellationReasonOtherDescriptionforRefund}
								onChangeCancellationReasonOtherDescriptionforRefund={setCancellationReasonOtherDescriptionforRefund}
								/** */
				
								/*Need to talk to SP */
								needToTalkToSPOptions={needToTalkToSPOptions}
								selectedNeedToTalkToSPOption={selectedNeedToTalkToSPOption}
								setSelectedNeedToTalkToSPOption={setSelectedNeedToTalkToSPOption}
								onUpdateNeedToTalkToSPFlag={onUpdateNeedToTalkToSPFlag}
								/*End*/
				
								/*Feedback Modal*/
								//toggleShowFeedbackModal={handleOnShowFeedback}

								/*Show more*/
								//SearchByDropdownList={SearchByDropdownList}
								isSearchByDropdownOpens={isSearchByDropdownOpens}
								togglesSearchByVisibility={togglesSearchByVisibility}
								SearchsDropdownRef={SearchsDropdownRef}
								onKnowMoreClick={onKnowMoreClick}
								selectedServiceForKnowMore={selectedServiceForKnowMore}
								onClearFilterSearch={handleClearFilterSearch}
								 
								 
								ExpandedChange={ExpandedChange}
								setExpandedChange={setExpandedChange}

						    />
						{
							showFilterModal&&(
								<ToolsTemplateFilterModal
									isOpen={showFilterModal}
									toggleModal={toggleFilterModal}

									onSearchClicked={handleSearchClick}
									onClearFilterSearch={handleClearFilterSearchss}
 
								
									toggleAllForServiceStatusFilter={toggleAllForServiceStatusFilter}
									toggleSelectionForServiceStatusFilter={toggleSelectionForServiceStatusFilter}
									selectedServiceStatusListForFilter1={selectedServiceStatusListForFilter1}
									serviceStatusNameListForFilter1={serviceStatusNameListForFilter1}

									 
									packageNameListForFilter={packageNameListForFilter}
									selectedPackageNameListForFilter={selectedPackageNameListForFilter}
									toggleAllForPackageFilter={toggleAllForPackageFilter}
									toggleSelectionForPackageFilter={toggleSelectionForPackageFilter}


									 
									 
								/>
							)
						}

						{
							showUserProfileModal&&
							(
								<UserProfileModal
									isOpen={showUserProfileModal}
									toggleModal={toggleUserProfileModal}
									toggleUserProfileModal={handleOnClickUser}
									userProfileInitData={userProfileInitData}
									userProfileEditableData={userProfileEditableData}
									onInputChange={handleUserProfileDataChanged}
									createUserProfile={createUserProfile}
									updateSelectedServiceRequest={updateSelectedServiceRequest}
									nUserId={nUserId}
									nResourceInstanceIdForUserProfile={nResourceInstanceIdForUserProfile}
									showFacilitatorEngagementView={false}
									sBusinessNameForUserProfile={sBusinessNameForUserProfile}
									sSectorNameForUserProfile={sSectorNameForUserProfile}
									sCurrentServiceRequestStateForUserProfile={sCurrentServiceRequestStateForUserProfile}
									refExternalServicePartnerEmailIDForFeedback={refExternalServicePartnerEmailIDForFeedback}
								/>
								 
							)
						}
						{
								showServiceFeedbackModal&&
								(
									<UserFeedbackModal
										isOpen={showServiceFeedbackModal}
										toggleModal={toggleServiceFeedbackModal}
										sEmailId={null}
										nResourceInstanceId={nResourceInstanceIdForFeedback}
										sServiceNameForFeedback={sServiceNameForFeedback}
										refExternalServicePartnerEmailIDForFeedback={refExternalServicePartnerEmailIDForFeedback}
									>
									</UserFeedbackModal>
								)
						}

					</>
				}
			</div>
		</>

	);
}